/** Copyright © 2025 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import type { SelectorOption } from 'hems';

import type { ValueType } from 'hems/common/utils';

export const LANGUAGE = {
  EN: 'en',
  MX: 'mx',
} as const;

export type LanguageValue = ValueType<typeof LANGUAGE>;

export const DEFAULT_LANGUAGE = LANGUAGE.EN;

export const LANGUAGE_TEXT_MAP: { [key in LanguageValue]: string } = {
  [LANGUAGE.EN]: 'English',
  [LANGUAGE.MX]: 'Español',
} as const;

export const USLanguageOptions: SelectorOption<LanguageValue>[] = [
  { text: LANGUAGE_TEXT_MAP[LANGUAGE.EN], value: LANGUAGE.EN },
  { text: LANGUAGE_TEXT_MAP[LANGUAGE.MX], value: LANGUAGE.MX },
];

/* Internationalization Locale Code */
export const INTL_LOCALE = {
  EN: 'en',
  MX: 'es-MX',
} as const;

export type IntlLocaleValue = ValueType<typeof INTL_LOCALE>;

export const INTL_LOCALE_MAP: { [key in LanguageValue]: IntlLocaleValue } = {
  [LANGUAGE.EN]: INTL_LOCALE.EN,
  [LANGUAGE.MX]: INTL_LOCALE.MX,
} as const;

export const GOOGLE_MAP_LANGUAGE_MAP: { [key in IntlLocaleValue]: string } = {
  [INTL_LOCALE.EN]: 'en',
  [INTL_LOCALE.MX]: 'es',
} as const;
